import toast, { ToastOptions } from 'react-hot-toast';

import { colors } from '@/colors';
import { InfoIcon } from '@/components/InfoIcon';

export const toastInfo = (msg: string | React.ReactElement, options?: ToastOptions) => {
  return toast.success(msg, {
    duration: 3000,
    position: 'top-center',
    icon: <InfoIcon />,
    style: { zIndex: 9999999, backgroundColor: colors.white },
    ...options,
  });
};
